/**
 * Redux reducer for Search Experience v2 settings
 */

export const FETCH_V2_CONFIG = 'settingsV2/FETCH_V2_CONFIG';
export const FETCH_V2_CONFIG_SUCCESS = 'settingsV2/FETCH_V2_CONFIG_SUCCESS';
export const FETCH_V2_CONFIG_FAILURE = 'settingsV2/FETCH_V2_CONFIG_FAILURE';

export const ACTIVATE_PRODUCTION = 'settingsV2/ACTIVATE_PRODUCTION';
export const ACTIVATE_PRODUCTION_SUCCESS = 'settingsV2/ACTIVATE_PRODUCTION_SUCCESS';
export const ACTIVATE_PRODUCTION_FAILURE = 'settingsV2/ACTIVATE_PRODUCTION_FAILURE';

export const CLEAR_ERROR = 'settingsV2/CLEAR_ERROR';

export const fetchV2Config = ({ shopId, mode }) => ({
  type: FETCH_V2_CONFIG,
  payload: { shopId, mode },
});

export const activateProduction = ({ shopId }) => ({
  type: ACTIVATE_PRODUCTION,
  payload: { shopId },
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

const initialState = {
  previewConfig: null,
  productionConfig: null,
  loading: false,
  saving: false,
  error: null,
};

const settingsV2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_V2_CONFIG:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_V2_CONFIG_SUCCESS: {
      const { mode, data } = action.payload;
      return {
        ...state,
        loading: false,
        [mode === 'preview' ? 'previewConfig' : 'productionConfig']: data,
      };
    }

    case FETCH_V2_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTIVATE_PRODUCTION:
      return {
        ...state,
        saving: true,
        error: null,
      };

    case ACTIVATE_PRODUCTION_SUCCESS:
      return {
        ...state,
        saving: false,
        productionConfig: action.payload,
      };

    case ACTIVATE_PRODUCTION_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.payload,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default settingsV2Reducer;
